export enum BillingCallbackStatus {
  SUCCESS = 'success',
  CANCEL = 'cancel'
}